import React from 'react';
import SearchIcon from '@material-ui/icons/Search';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const useStyles = buildUseStyles('EmptyResults', ((theme) => ({
  root: {
    height: theme.dimensions.sm,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  icon: {
    transform: 'scale(2)',
    fill: theme.palette.facet.primaryGray,
  },
  title: {
    paddingTop: theme.spacing(3),
  },
  subtitle: {
    paddingTop: theme.spacing(1),
  },
})));

const EmptyResults = () => {
  const classes = useStyles();

  return (
    <Box
      className={classes.root}
    >
      <SearchIcon
        className={classes.icon}
      />
      <Typography
        className={classes.title}
        variant={'h5'}
        weight={'bold'}
        color={'primaryGray'}
      >
        {'No results found'}
      </Typography>
      <Typography
        className={classes.subtitle}
        variant={'body1'}
        weight={'medium'}
        color={'primaryGray'}
      >
        {'Please try again with a different query.'}
      </Typography>
    </Box>
  );
};

export default EmptyResults;
